import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Form, FormGroup, Input, Row } from "reactstrap";
import Select from "react-select";
import moment from "moment";

import CommonDataTable from "../../../../../share-components/table/commonDataTable";
import { getSaleOfferRemovedProducts } from "../../../store/saleOfferSlice";

const customStyles = {
    control: (base) => ({
        ...base,
        minHeight: 50,
        border: "none",
    }),
};

const money = (value) => (value === null || value === undefined ? '-' : `£${Number(value).toFixed(2)}`);

// Seller products the price sync took off this offer because the seller put them on sale (GOD-TK-198).
export const RemovedProductsSection = (props) => {
    const { saleOfferId } = props;
    const dispatch = useDispatch();

    const [rows, setRows] = useState([]);
    const [count, setCount] = useState(0);
    const [sellers, setSellers] = useState([]);
    const [brands, setBrands] = useState([]);
    const [search, setSearch] = useState('');
    const [seller, setSeller] = useState(null);
    const [brand, setBrand] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [timer, setTimer] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        dispatch(getSaleOfferRemovedProducts({
            id: saleOfferId,
            search,
            seller_id: seller?.id,
            brand_id: brand?.id,
            page: currentPage,
            pageSize,
        })).then(res => {
            if (!res.error) {
                setRows(res.payload.data);
                setCount(res.payload.count);
                setSellers(res.payload.sellers);
                setBrands(res.payload.brands);
            }
            setLoading(false);
        });
    }, [dispatch, saleOfferId, search, seller, brand, currentPage, pageSize]);

    const tableColumns = [
        {
            name: 'Date & Time',
            selector: row => moment(row.removed_at).format('DD MMM YYYY HH:mm'),
            minWidth: '150px',
        },
        {
            name: 'Product',
            selector: row => <div className="py-2">
                <Link to={`${process.env.PUBLIC_URL}/product/${row.product_id}/edit`}>{row.product_name}</Link>
                <div className="text-muted">{row.product_code}</div>
            </div>,
            minWidth: '220px',
            wrap: true,
        },
        {
            name: 'SKU',
            selector: row => row.sku,
            minWidth: '150px',
        },
        {
            name: 'Seller',
            selector: row => row.seller_name,
        },
        {
            name: 'Brand',
            selector: row => row.brand_name,
        },
        {
            name: 'Our Offer Price',
            selector: row => money(row.offer_sale_price),
            right: true,
        },
        {
            name: 'Seller RRP / Sale',
            selector: row => `${money(row.seller_compare_at_price)} / ${money(row.seller_price)}`,
            right: true,
            minWidth: '160px',
        },
        {
            name: 'Reason',
            selector: row => row.reason,
            minWidth: '220px',
            wrap: true,
        },
    ];

    return (
        <Fragment>
            <Card className="ribbon-wrapper">
                <CardBody>
                    <div className="ribbon ribbon-clip ribbon-danger">Removed Products</div>
                    <Row>
                        <Col md={4}>
                            <Form onSubmit={(e) => e.preventDefault()}>
                                <FormGroup className="m-0">
                                    <Input
                                        bsSize="lg"
                                        type="text"
                                        onChange={(e) => {
                                            clearTimeout(timer);
                                            const value = e.target.value;
                                            setTimer(setTimeout(() => {
                                                setCurrentPage(1);
                                                setSearch(value);
                                            }, 500));
                                        }}
                                        placeholder="Search SKU / Name / Code"
                                    />
                                </FormGroup>
                            </Form>
                        </Col>
                        <Col md={3}>
                            <Select
                                placeholder="Seller"
                                className="select2-filter"
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                isClearable
                                styles={customStyles}
                                options={sellers}
                                value={seller}
                                onChange={(option) => {
                                    setCurrentPage(1);
                                    setSeller(option);
                                }}
                                components={{ IndicatorSeparator: () => null }}
                            />
                        </Col>
                        <Col md={3}>
                            <Select
                                placeholder="Brand"
                                className="select2-filter"
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                isClearable
                                styles={customStyles}
                                options={brands}
                                value={brand}
                                onChange={(option) => {
                                    setCurrentPage(1);
                                    setBrand(option);
                                }}
                                components={{ IndicatorSeparator: () => null }}
                            />
                        </Col>
                    </Row>
                    <div className="table-responsive product-table mt-3">
                        <CommonDataTable
                            headerColumns={tableColumns}
                            gridData={rows}
                            noAction
                            progressPending={loading}
                            paginationServer
                            paginationTotalRows={count}
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            onChangeRowsPerPage={(size) => {
                                setCurrentPage(1);
                                setPageSize(size);
                            }}
                            onChangePage={setCurrentPage}
                            paginationDefaultPage={currentPage}
                            paginationPerPage={pageSize}
                            noDataComponent={<div className="p-4">No products removed</div>}
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
}
